module.exports = __webpack_public_path__ + "static/Avalara-2bb28d95e6519d5bb7d33f92b7acb772.jpg";